import type { JSX } from "react";
import Icon from "../icon";
import Text from "../text";
import View from "../view";
import type { IconSizes } from "@/components/types";
import cn from "@/utils/cn";

interface LoaderProps {
  className?: string;
  size?: keyof typeof IconSizes;
  color?: string;
  fullScreen?: boolean;
}

/**
 * @name Loader
 * @description A premium, animated SVG spinner for loading states.
 */
const Loader = ({
  className = "",
  size = "4x",
  color = "text-primary",
  fullScreen = false
}: LoaderProps): JSX.Element => (
  <View
    className={cn(
      "flex items-center justify-center p-2",
      fullScreen
        ? "fixed inset-0 z-[9999] backdrop-blur-sm w-screen h-screen"
        : "w-auto h-auto",
      className
    )}
    role="status"
    aria-label="Cargando..."
    aria-busy="true"
  >
    <View className={cn("relative animate-spin", color)}>
      <Icon name="spinner" size={size} />
      <Text className="sr-only">Cargando...</Text>
    </View>
  </View>
);

export default Loader;
